(function() {

	"use strict";

	angular.module( "ATMGurus" )


	/*
	*
	*		trustAsResourceUrl
	*	ensure $sce we're not trying to break stuff
	*	it might kinda defeatsthe purpose though
	*/

	.filter('trustAsResourceUrl', [
		'$sce',
		function( $sce ) {
			return function( val ) {
				return $sce.trustAsResourceUrl( val );
			}
		}
	])
})()


// WEBPACK FOOTER //
// ./src/app/filters/trustAsResourceUrl.js